import { render } from "./BatchImport.vue?vue&type=template&id=2dadcf7c&scoped=true"
import script from "./BatchImport.vue?vue&type=script&lang=js"
export * from "./BatchImport.vue?vue&type=script&lang=js"

import "./BatchImport.vue?vue&type=style&index=0&id=2dadcf7c&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dadcf7c"]])

export default __exports__